import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'activity-log',
});

export const dashboardRouteRef = createRouteRef({
  id: 'activity-log-dashboard',
});
